<template>
  <a-card
    :bordered="false"
    :tab-list="[
    {key: 'IN_SELL',tab:$t('IN_SELL')|| '销售中'},
    {key:'OFF',tab:$t('OFF')||'下架'},
    {key:'PRESELL',tab:$t('PRESELL')||'预售'}
    ]"
    :active-tab-key="searchForm.data.status"
    @tabChange="key => onTabChange(key)"
  >
    <div>
      <div class="operation-wrap">
        <a-form-model
          layout="inline"
          label-position="top"
          :model="searchForm.data">
          <a-form-model-item label="系列">
            <a-input v-model="searchForm.data.seriesId" style="width: 150px" allowClear placeholder="请输入系列名"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('NAME')|| '商品名'">
            <a-input v-model="searchForm.data.name" style="width: 150px" allowClear placeholder="请输入商品名或编号"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('OPERATION') || '操作'">
            <a-space>
              <a-button
                type="primary"
                @click="getGoodsList">{{ $t('SEARCH') || '查询' }}
              </a-button>
              <a-button type="primary" @click="addGoods">
                {{ $t('ADD') || '添加' }}
              </a-button>
              <a-button type="primary" @click="mulitiInSell">{{'上架' }}</a-button>
              <a-button type="danger" @click="mulitiOff">{{ $t('OFF') || '下架' }}</a-button>
              <a-button type="primary" @click="importGoodsExcel">{{ $t('IMPORT') || '导入' }}</a-button>
              <a-button type="primary" @click="exportExcel">{{ $t('EXPORT') || '导出' }}</a-button>
              <a-button type="primary" @click="updateGoodsPriceExcel">批量更新商品价格</a-button>
              <a-button
                type="danger"
                v-if="searchForm.data.status==='OFF'"
                @click="mulitiDelete">{{ $t('DELETE') || '删除' }}
              </a-button>

            </a-space>
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-table
        ref="dragTable"
        :scroll="{ y: 'calc(100vh - 300px)' }"
        row-key="id"
        :row-selection="{ selectedRowKeys: table.sectionData,onChange:handleSelectionChange }"
        :data-source="table.data"
        :columns="table.columns"
        :loading="table.loading"
        @selection-change="handleSelectionChange"
        @change="handleTableChange"
        :pagination="{
            current: table.pagination.current,
            pageSize: table.pagination.pageSize,
            total: table.pagination.total,
            showSizeChanger: true,
            showLessItems: true,
            pageSizeOptions: ['5','10','30','50','100'],
            showQuickJumper: true,
            showTotal: (total,range)=> `第 ${range[0]} - ${range[1]} 条，总计 ${total} 条`,
            onChange:  onPageChange,
            onShowSizeChange: onSizeChange
        }"
      >
        <span slot="img" slot-scope="text, record">
           <a-avatar :size="80" shape="square" :src="record.coverPath"/>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="inspirationGoods(record.id)">{{ $t('INSPIRATION') || '灵感' }}</a-button>
          <a-button type="link" @click="editGoods(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
          <template v-if="searchForm.data.status==='OFF'">
          <a-divider type="vertical"/>
            <a-button type="link" @click="deleteGoods(record.id)">{{ $t('DELETE') || '删除' }}
          </a-button>

          </template>
        </span>
        <template slot="sort">
          <a-icon type="drag" style="font-size: 25px;"/>
        </template>
      </a-table>
    </div>
    <a-drawer
      size="80%"
      title="SKU详情"
      v-model="skuForm.visible"
      append-to-body>
      <website-goods-sku-list
        v-if="skuForm.visible"
        :goods-id="skuForm.data.id"
        :goods-code="skuForm.data.code"
      />
    </a-drawer>
    <a-modal
      :footer="null"
      title="商品详情"
      append-to-body
      :close-on-click-modal="false"
      fullscreen
      v-model="form.visible">
      <website-goods-edit
        v-if="form.visible"
        :goods-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-goods-edit>
    </a-modal>
    <a-modal
      v-model="excelForm.visible"
      title="导入网站商品"
      @ok="closeModal"
      @cancel="onCancel">
      <a-form-model-item
        label="导入excel"
        required>
        <div :key="ImgKey">
          <website-excel-uploader/>
        </div>
      </a-form-model-item>
    </a-modal>
    <a-modal
      :footer="null"
      v-model="excelPriceForm.visible"
      title="批量更新价格">
      <!--      @ok="closeModal"-->
      <!--      @cancel="onCancel">-->
      <goods-price-update
        v-if="excelPriceForm.visible"
        :on-cancel-handler="closeGoldPriceForm"
        :on-submit-handler="closeGoldPriceForm">
      </goods-price-update>
      <!--      <a-form-model-item-->
      <!--        label="导入excel"-->
      <!--        required>-->
      <!--        <div :key="ImgKey">-->
      <!--          <website-excel-goods-price-uploader/>-->
      <!--        </div>-->
      <!--      </a-form-model-item>-->
    </a-modal>
  </a-card>
</template>

<script>
import {
  _deleteGoods,
  _importGoods,
  _multiUpdateGoods,
  _offGoods,
  _queryWebsiteGoods,
  _updateGoodsSort,
} from '@/api/websiteGoodsApi';
import { _queryGoodsSeriess, } from '@/api/goodsSeriesApi';
import WebsiteGoodsEdit from './WebsiteGoodsEdit.vue';
import WebsiteGoodsSkuList from './WebsiteGoodsSkuList.vue';
import WebsiteExcelUploader from '@/components/WebsiteExcelUploader.vue';
// import WebsiteExcelGoodsPriceUploader from '@/components/WebsiteExcelGoodsPriceUploader.vue';
import Sortable from 'sortablejs';
import GoodsPriceUpdate from '@/views/website/goods/GoodsPriceUpdate.vue';

// import GoodsSizeItems from './GoodsSizeItems.vue';

async function getGoodsList() {
  this.table.loading = true;
  const { order } = this.table.sort;
  const result = await _queryWebsiteGoods({
    seriesId: this.searchForm.data.seriesId,
    status: this.searchForm.data.status,
    name: this.searchForm.data.name,
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction: order === 'ascend' ? 'ASC' : 'DESC',
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function editSku(row) {
  this.skuForm.data.id = row.id;
  this.skuForm.data.code = row.code;
  this.skuForm.visible = true;
}

function goodsImport() {
  this.goodsImportForm.visible = true;
}

function exportExcel() {
  const status = this.searchForm.data.status === 'ALL' ? '' : this.searchForm.data.status;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  window.open(`${process.env.VUE_APP_BASE_URL}/website-goods-export?status=${status}&sort=${this.table.sort.prop}`);
}

function addGoods() {
  this.$router.push('/website-goods-add');
}

function detailGoodsSize(goodsSeriesId) {
  this.goodsForm.data.id = goodsSeriesId;
  this.goodsForm.visible = true;
}

function handleSelectionChange(selectedRowKeys) {
  this.table.sectionData = selectedRowKeys;
}

function inspirationGoods(goodsId) {
  this.$router.push(`/goods-inspiration/${goodsId}`);
}

function priceGoods(goodsId) {
  this.$router.push(`/goods-price/${goodsId}`);
}

function editGoods(goodsId) {
  this.$router.push(`/website-goods/${goodsId}`);
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  if (sorter.field) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    };
  }
  this.getGoodsList();
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsList();
}

function closeGoldPriceForm() {
  this.excelPriceForm.visible = false;
  this.getGoodsList();
}

function onCancel() {
  this.getGoodsList();
}

async function deleteGoods(goodsId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoods(goodsId);
      this.$message.success('删除成功');
      await this.getGoodsList();
    },
  });
}

async function offGoods(goodsId) {
  this.$confirm({
    title: '是否下架？',
    content: '',
    onOk: async () => {
      await _offGoods(goodsId);
      this.$message({
        type: 'success',
        message: '下架成功!',
      });
      await this.getGoodsList();
    },
  });
}

function handleSizeChange(current, pageSize) {
  this.table.pagination.current = current;
  this.table.pagination.pageSize = pageSize;
  this.getGoodsList();
}

function handlePageChange(val) {
  this.table.pagination.current = val;
  this.getGoodsList();
}

function mulitiInSell() {
  if (this.table.sectionData.length === 0) {
    return;
  }
  this.$confirm({
    title: '是否上架？',
    content: '',
    onOk: async () => {
      await _multiUpdateGoods(this.table.sectionData, 'IN_SELL');
      this.$message.success('设置成功');
      this.getGoodsList();
    },
  });
}

function closeImportForm() {
  this.goodsImportForm.visible = false;
  this.getGoodsList();
}

function mulitiOff() {
  if (this.table.sectionData.length === 0) {
    return;
  }
  this.$confirm({
    title: '是否下架？',
    content: '',
    onOk: async () => {
      await _multiUpdateGoods(this.table.sectionData, 'OFF');
      this.$message.success('设置成功');
      await this.getGoodsList();
    },
  });
}

function mulitiDelete() {
  if (this.table.sectionData.length === 0) {
    return;
  }
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _multiUpdateGoods(this.table.sectionData, 'REMOVE');
      this.$message.success('删除成功');
      this.getGoodsList();
    },
  });
}

const rowSelection = {
  onChange: (selectedRowKeys) => {
    this.table.sectionData = selectedRowKeys;
  },
};

function onTabChange(key) {
  this.searchForm.data.status = key;
  this.table.pagination.page = 1;
  this.getGoodsList();
}

function importGoodsExcel() {
  this.excelForm.visible = true;
}

function updateGoodsPriceExcel() {
  this.excelPriceForm.visible = true;
}

function closeModal() {
  this.$confirm({
    title: '是否导入商品数据？',
    content: '',
    onOk: async () => {
      // 把上传解析后的数据加到数据库
      const goods = JSON.parse(window.localStorage.getItem('goods'));
      const goodsAttributeValue = JSON.parse(window.localStorage.getItem('goodsAttributeValue'));
      const goodsSKU = JSON.parse(window.localStorage.getItem('goodsSKU'));
      const goodsSkuAttributeValue = JSON.parse(window.localStorage.getItem('goodsSkuAttributeValue'));
      await _importGoods({
        goods: goods,
        goodsAttributeValue: goodsAttributeValue,
        goodsSKU: goodsSKU,
        goodsSkuAttributeValue: goodsSkuAttributeValue,
      });
      // this.$message.success('导入成功');
      await this.getGoodsList();
      this.excelForm.visible = false;
    },
  });
}

async function updateSortList(oldIndex, newIndex) {
  const idStr = this.table.data.map(x => x.id).join(',')
  const sortStr = this.table.data.map(x => x.sort).join(',')
  const result = await _updateGoodsSort({
    idStr,
    sortStr,
    oldIndex,
    newIndex
  })
  if (result) {
    this.$message.success('移动排序成功')
    await this.getGoodsList()
  }
}

function initSortable() {
  const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
  const dragTable = Sortable.create(el, {
    handle: 'td:nth-child(7)',
    animation: 150,
    // 利用更新
    onUpdate: (e) => {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      if (oldIndex === newIndex) {
        return
      }
      this.updateSortList(oldIndex, newIndex)
    },
  })
}

const columns = [
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '商品名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '开始价格',
    dataIndex: 'startPrice'
  },
  {
    title: '结束价格',
    dataIndex: 'endPrice'
  },
  {
    title: '数量',
    dataIndex: 'quantity'
  },
  {
    title: '拖拽排序',
    align: 'center',
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: 'WebsiteGoodsList',
  components: {
    GoodsPriceUpdate,
    WebsiteGoodsSkuList,
    WebsiteGoodsEdit,
    WebsiteExcelUploader,
    // WebsiteExcelGoodsPriceUploader,
    // GoodsInspirationEdit,
  },
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_URL}/import`,
      ImgKey: '',
      rowSelection,
      uploadGoodsButtonLoading: false,
      category: {
        data: [],
      },
      series: {
        data: [],
      },
      brand: {
        data: [],
      },
      excelForm: {
        visible: false,
      },
      excelPriceForm: {
        visible: false,
      },
      searchForm: {
        data: {
          status: 'IN_SELL',
          name: '',
          categoryId: '',
          brandId: '',
          seriesId: '',
          memberOnly: '',
          brandName: '',
        },
      },
      goodsImportForm: {
        visible: false,
        numIds: ''
      },
      goodsForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      skuForm: {
        data: {
          id: null,
          code: null,
        },
        visible: false,
      },
      inspiration: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns,
        loading: false,
        data: [],
        sectionData: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descend',
        },
      },
    };
  },
  methods: {
    getGoodsList,
    deleteGoods,
    editGoods,
    offGoods,
    addGoods,
    closeForm,
    closeGoldPriceForm,
    editSku,
    handleSizeChange,
    handlePageChange,
    handleSelectionChange,
    mulitiInSell,
    mulitiOff,
    mulitiDelete,
    handleTableChange,
    onTabChange,
    goodsImport,
    closeImportForm,
    importGoodsExcel,
    updateGoodsPriceExcel,
    closeModal,
    inspirationGoods,
    priceGoods,
    onCancel,
    detailGoodsSize,
    exportExcel,
    initSortable,
    updateSortList,
    onPageChange(page, pageSize) {
      this.table.pagination.current = page;
      this.table.pagination.pageSize = pageSize;
      this.getGoodsList();
    },
    onSizeChange(current, size) {
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = size;
      this.getGoodsList();
    },
  },
  mounted() {
    this.initSortable();
  },
  async created() {
    const seriesResult = await _queryGoodsSeriess({});
    this.series.data = seriesResult.content;
    await this.getGoodsList();
  },
  async activated() {
    console.log('this.$route.meta.isUseCache: ' + this.$route.meta.isUseCache);
    if (!this.$route.meta.isUseCache) {
      await this.getGoodsList();
    }
  }
};
</script>

<style scoped>

.pagination-class {
  margin-top: 30px;
}

</style>
